import { PRODUCT_SUITE_APPS } from './types';
import type { ProductSuiteId, AppConfig, AppId } from './types';

// Undefined for a platform tool (no suite) or an unlisted app.
export function getProductSuite(id: AppId): ProductSuiteId | undefined {
	return PRODUCT_SUITE_APPS.find((suite) => (suite.apps as readonly AppId[]).includes(id))?.id;
}

// Needs one of `datasets` (none = no constraint) and no `false` live signal.
export function isAppAvailable(
	{ datasets }: AppConfig<unknown>,
	availableDatasets: ReadonlySet<string>,
	runtimeAvailable?: boolean
): boolean {
	return (
		runtimeAvailable !== false &&
		(datasets.length === 0 || datasets.some((d) => availableDatasets.has(d)))
	);
}
